module.exports = __webpack_public_path__ + "img/zilan.57adfb7d.png";